import React, { useEffect, useState } from 'react'

import { Box, Flex, Text } from '@chilipiper/design-system'

import { generateColor, getInitials } from '../helpers'
import { AvatarProps } from '../types'
import { StyledBackground, StyledImage } from './styles'

export const AvatarPlaceholder = ({
  id,
  name,
  image,
  size = 6,
  fontSize = 12,
  borderRadius = 'full',
  isTwoInitials,
  indicator,
  indicatorContainerProps = {},
  imageStyle = {},
  crossOrigin,
  fallbackComponent,
  'data-test-id': dataTestId,
}: AvatarProps) => {
  const letters = getInitials(name, isTwoInitials)
  const color = generateColor(id || name)
  const [error, setError] = useState(false)

  useEffect(() => {
    setError(false)
  }, [image])

  return (
    <Flex position='relative' data-test-id={dataTestId} w={size} h={size}>
      {image && !error ? (
        <StyledImage
          data-test-id='View-image'
          alt='View Image'
          src={image}
          borderRadius={borderRadius}
          style={imageStyle}
          crossOrigin={crossOrigin}
          onError={() => setError(true)}
        />
      ) : (
        fallbackComponent || (
          <Box
            data-test-id='View-image-fallback'
            w={size}
            h={size}
            borderRadius={borderRadius}
            overflow='hidden'
            position='relative'
          >
            <StyledBackground bgColor={color} alignItems='center' justifyContent='center'>
              <Text fontSize={fontSize} fontWeight={600} color='white'>
                {letters}
              </Text>
            </StyledBackground>
          </Box>
        )
      )}
      {indicator && (
        <Box
          right={0}
          bottom={0}
          borderRadius='full'
          position='absolute'
          {...indicatorContainerProps}
        >
          {indicator}
        </Box>
      )}
    </Flex>
  )
}
